import magnifiAPIInstance from "./apiInstance";
import uploadToS3 from "./s3UploadApiInstance";

export const commonAPIs = {
  getPreSignedUrl: ({ payload }) => magnifiAPIInstance.post(`get-presigned-url`, payload, { skipAuthHeader: true }),
  updateDownloadStatus: ({ payload }) => magnifiAPIInstance.post(`getDownloadStatus`, payload),
  getOTP: ({ payload }) => magnifiAPIInstance.post(`/otp-verification`, payload),
  uploadToS3: ({ payload }) => uploadToS3(payload),
  getContentType: ({ payload }) => magnifiAPIInstance.post(`/get-mime-type`, payload),
  checkValidStream: ({ payload }) => magnifiAPIInstance.post(`/stream/validation`, payload),
  uploadBumper: ({ payload }) => magnifiAPIInstance.post(`/sony_create_advertise_video`, payload),
  getUrlDuration: ({ payload }) => magnifiAPIInstance.post(`/timeline/duration`, payload),
  getWorkspaceConfig: ({ workspaceId }) => magnifiAPIInstance.get(`/workspace-config/${workspaceId}`),
  syncTv2PlayerData: ({ payload }) => magnifiAPIInstance.post(`/tv2_player_mapping`, payload),
  passThroughDownload: ({ payload }) => magnifiAPIInstance.post(`/api/v3/downloadVideo`, payload),
};
